var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M273 12c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1h-.456c.059.281.172.48.334.61-.012-.01-.005-.013.017-.011l.835.119c.547.085.904.184 1.171.377.291.21.47.518.55.905H276c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1h-2c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1h.4c-.024-.04-.053-.072-.085-.095-.082-.06-.286-.12-.598-.176l-.657-.096c-.462-.064-.635-.103-.809-.243-.093-.075-.177-.158-.252-.248-.074.09-.159.173-.252.248-.174.14-.347.179-.808.243l-.657.096c-.312.055-.516.116-.599.176-.032.023-.06.055-.085.095H270c.552 0 1 .448 1 1v2c0 .552-.448 1-1 1h-2c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1h.548c.079-.387.259-.695.55-.905.267-.193.624-.292 1.17-.377l.836-.12c.022 0 .03.003.017.012.162-.13.275-.329.333-.61H271c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1h2zm3 7h-1.167l-.333.001V19h-.5v2h2v-2zm-6.835 0H268v2h2v-2h-.502v.001l-.333-.001zm3.335-4h.5v-2h-2v2h1.5z",
    transform: "translate(-1273 -130) translate(1006 118)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOther);
export default __webpack_public_path__ + "static/media/profile-other.bb4d83b27157796d4d7478ce3f9fd7d0.svg";
export { ForwardRef as ReactComponent };